export const languageCountryMap = {
  ab: 'GE',
  ace: 'ID',
  ach: 'UG',
  af: 'ZA',
  sq: 'AL',
  am: 'ET',
  ar: 'SA',
  hy: 'AM',
  as: 'IN',
  az: 'AZ',
  eu: 'ES',
  be: 'BY',
  bn: 'BD',
  bs: 'BA',
  br: 'FR',
  bg: 'BG',
  yue: 'HK',
  ca: 'ES',
  ceb: 'PH',
  ny: 'MW',
  zh: 'CN',
  'zh-TW': 'TW',
  hr: 'HR',
  cs: 'CZ',
  da: 'DK',
  dv: 'MV',
  nl: 'NL',
  dz: 'BT',
  en: 'GB',
  eo: 'EO',
  et: 'EE',
  ee: 'GH',
  fj: 'FJ',
  tl: 'PH',
  fi: 'FI',
  fr: 'FR',
  'fr-CA': 'CA',
  fy: 'NL',
  ff: 'SN',
  gl: 'ES',
  ka: 'GE',
  de: 'DE',
  el: 'GR',
  gn: 'PY',
  gu: 'IN',
  ht: 'HT',
  ha: 'NG',
  haw: 'US',
  iw: 'IL',
  hi: 'IN',
  hmn: 'CN',
  hu: 'HU',
  is: 'IS',
  ig: 'NG',
  ilo: 'PH',
  id: 'ID',
  ga: 'IE',
  it: 'IT',
  ja: 'JP',
  jw: 'ID',
  kn: 'IN',
  kk: 'KZ',
  km: 'KH',
  rw: 'RW',
  ko: 'KR',
  ku: 'TR',
  ckb: 'IQ',
  ky: 'KG',
  lo: 'LA',
  la: 'VA',
  lv: 'LV',
  ln: 'CD',
  lt: 'LT',
  lg: 'UG',
  lb: 'LU',
  mk: 'MK',
  mai: 'IN',
  mg: 'MG',
  ms: 'MY',
  ml: 'IN',
  mt: 'MT',
  mi: 'NZ',
  mr: 'IN',
  mn: 'MN',
  my: 'MM',
  ne: 'NP',
  no: 'NO',
  oc: 'FR',
  or: 'IN',
  om: 'ET',
  ps: 'AF',
  fa: 'IR',
  pl: 'PL',
  pt: 'BR',
  'pt-PT': 'PT',
  pa: 'IN',
  'pa-Arab': 'PK',
  qu: 'PE',
  ro: 'RO',
  rn: 'BI',
  ru: 'RU',
  sm: 'WS',
  sg: 'CF',
  sa: 'IN',
  gd: 'GB',
  sr: 'RS',
  st: 'LS',
  sn: 'ZW',
  sd: 'PK',
  si: 'LK',
  sk: 'SK',
  sl: 'SI',
  so: 'SO',
  es: 'ES',
  su: 'ID',
  sw: 'KE',
  sv: 'SE',
  tg: 'TJ',
  ta: 'IN',
  tt: 'RU',
  te: 'IN',
  th: 'TH',
  ti: 'ER',
  ts: 'ZA',
  tn: 'BW',
  tr: 'TR',
  tk: 'TM',
  ak: 'GH',
  uk: 'UA',
  ur: 'PK',
  ug: 'CN',
  uz: 'UZ',
  vi: 'VN',
  cy: 'GB',
  xh: 'ZA',
  yi: 'IL',
  yo: 'NG',
  zu: 'ZA',
  he: 'IL',
  jv: 'ID',
  'zh-CN': 'CN',
};
